import { ReactNode, ReactElement } from "react";
import classNames from "clsx";

import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import { OverlayChildren } from "react-bootstrap/Overlay";

import "./styles.scss";

type PartogramViewProps = {
	children: ReactNode;
};

function PartogramViewRoot({ children }: PartogramViewProps) {
	return <div className="pe-20 d-flex align-items-center">{children}</div>;
}

function PartogramViewLabel({ children }: PartogramViewProps) {
	return <div className="partogram-fetus-chart-label fs-7 text-gray-700">{children}</div>;
}

function PartogramViewTable({ children }: PartogramViewProps) {
	return (
		<div className="table-responsive w-100">
			<table className="table table-row-dashed border-dashed border-gray-600 table-row-gray-600 gy-7 partogram-fetus-charts-table">
				<tbody>{children}</tbody>
			</table>
		</div>
	);
}

type PartogramViewTableDataProps = {
	children: ReactNode;
	textSize?: "sm" | "lg";
	overlay?: OverlayChildren;
};

function PartogramViewTableData({
	children,
	textSize = "sm",
	overlay,
}: PartogramViewTableDataProps) {
	const textClassName = textSize === "sm" ? "fs-8" : "fs-3";

	return (
		<td className="text-center align-middle">
			<div className={classNames("fw-bold text-gray-700", textClassName)}>
				{overlay ? (
					<OverlayTrigger trigger={["hover", "focus"]} overlay={overlay}>
						{children as ReactElement}
					</OverlayTrigger>
				) : (
					children
				)}
			</div>
		</td>
	);
}

export const PartogramView = PartogramViewRoot as typeof PartogramViewRoot & {
	Label: typeof PartogramViewLabel;
	Table: typeof PartogramViewTable;
	TableData: typeof PartogramViewTableData;
};

PartogramView.Label = PartogramViewLabel;
PartogramView.Table = PartogramViewTable;
PartogramView.TableData = PartogramViewTableData;
